import warning from "rc-util/es/warning";
export function legacyPropsWarning(props) {
  var picker = props.picker,
    disabledHours = props.disabledHours,
    disabledMinutes = props.disabledMinutes,
    disabledSeconds = props.disabledSeconds;
  if (picker === 'time' && (disabledHours || disabledMinutes || disabledSeconds)) {
    warning(false, "'disabledHours', 'disabledMinutes', 'disabledSeconds' will be removed in the next major version, please use 'disabledTime' instead.");
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-picker/es/utils/warnUtil.js
// module id = 618
// module chunks = 0